import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import About from "./pages/About";
import News from "./pages/News";
import Members from "./pages/Members";
import Events from "./pages/Events";
import Gallery from "./pages/Gallery";
import Blog from "./pages/Blog";
import Contact from "./pages/Contact";
import AdminDashboard from "./pages/AdminDashboard";
import AlumniRegistration from "./pages/AlumniRegistration";
import AlumniLogin from "./pages/AlumniLogin";
import Dashboard from './pages/Dashboard';
import ApprovalAdmin from "./pages/ApprovalAdmin";
import ApprovedAlumni from "./pages/ApprovedAlumni";
import PaymentSuccessPage from "./components/PaymentSuccessPage";
import DonatePage from "./components/DonatePage";
import CITAlumni from './pages/CITAlumni';
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import AdminLogin from "./components/AdminLogin";
import AdminProtectedRoute from "./components/AdminProtectedRoute";
import MemberList from "./pages/MemberList";

import '@fortawesome/fontawesome-free/css/all.min.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const savedUser = localStorage.getItem('loggedInUser');
    if (savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        console.error("Failed to parse logged-in user:", e);
        localStorage.removeItem('loggedInUser');
      }
    }
    setLoading(false);
  }, []);

  // Redirect if loading
  if (loading) {
    return (
      <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <Router>
      <Navbar user={user} setUser={setUser} />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<CITAlumni />} />
        <Route path="/about" element={<About />} />
        <Route path="/news" element={<News />} />
        <Route path="/members" element={<Members />} />
        <Route path="/events" element={<Events />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/alumni-register" element={<AlumniRegistration />} />
        <Route path="/donate" element={<DonatePage />} />
        <Route path="/donation-success" element={<PaymentSuccessPage />} />
        
        {/* ✅ Pass setUser to Login Page */}
        <Route path="/login" element={<AlumniLogin setUser={setUser} />} />
        
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/admin-login" element={<AdminLogin />} />

        {/* MemberList - Protected (requires approved alumni) */}
        <Route path="/MemberList" element={<MemberList user={user} />} />

        {/* Dashboard - Protected (requires login) */}
        <Route 
          path="/dashboard" 
          element={
            user ? (
              <Dashboard user={user} />
            ) : (
              <Navigate to="/login" replace />
            )
          } 
        />

        {/* Admin Routes - Protected by AdminProtectedRoute */}
        <Route
          path="/admin"
          element={
            <AdminProtectedRoute>
              <AdminDashboard />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/admin/approval"
          element={
            <AdminProtectedRoute>
              <ApprovalAdmin />
            </AdminProtectedRoute>
          }
        />

        <Route
          path="/admin/approved"
          element={
            <AdminProtectedRoute>
              <ApprovedAlumni />
            </AdminProtectedRoute>
          }
        />

        {/* Catch-all for unknown admin sub-routes */}
        <Route path="/admin/*" element={<Navigate to="/admin" replace />} />

        {/* 404 fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer />
    </Router>
  );
}

export default App;